var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSustentavel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-12 h-12 text-green-700 mx-auto",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "{2}",
    d: "M12 3C7.589 3 4 7 4 11.5c0 3.59 2.42 6.58 5.747 7.395a.75.75 0 01.61.75v.605a.75.75 0 00.75.75h1.786a.75.75 0 00.75-.75v-.605a.75.75 0 01.61-.75C17.58 18.08 20 15.09 20 11.5 20 7 16.411 3 12 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustentavel);
export default __webpack_public_path__ + "static/media/sustentavel.f77c754ad2d66b6d51997fd2c86d0757.svg";
export { ForwardRef as ReactComponent };